<template>
  <div id="device_tab"
       class="main-tab main-tab-o">
    <div class="dv-content-re">
      <img src="../assets/images/icon_re_bg.png"
           class="img-re-bg">
      <img src="../assets/images/icon_re_bottom.png"
           class="img-re-bottom">
      <div class="dv-content-s-re">
        <div class="tv-title">辽渔医院欢迎您的加入</div>
        <div class="dv-content-item-re">
          <div class="dv-re-white"></div>
          <div class="tv-re-title">招聘信息</div>
          <div class="dv-re-item"
               v-for="(item,index) in recruitlists"
               v-bind:key="index"
               @mouseover="MouseOver(index)"
               @mouseout="Mouseout(monindex = 100000)"
               :class='monindex === index ? "dv-re-items" : ""'
               @click="onDs(item.newsid)">
            <div class="tv-re-item-title"
                 :class='monindex === index ? "tv-re-item-titles" : ""'>{{item.title}}</div>
            <!-- <div class="tv-re-item-title1">职位描述：</div> -->
            <div class="tv-re-item-title2">{{ item.introduce }}</div>

          </div>
          <div class="dv-fenye">
            <el-pagination background
                           layout="prev, pager, next"
                           prev-text="上一页"
                           next-text="下一页"
                           :page-size='showCount'
                           :total="totalResult"
                           @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>

      </div>

    </div>

  </div>

</template>

<script>
import api from '../api/api'
export default {
  data () {
    return {
      monindex: 100000,
      showCount: 10,
      totalResult: 0,
      currentPage: 1,
      recruitlists: []
    }
  },
  created () {
    this.recruitlist()
  },
  methods: {
    MouseOver (index) {
      this.monindex = index
    },
    onDs (id) {
      this.$router.push({
        path: '/recruitDs',
        query: {
          id: id
        }
      })
    },
    //分页切换
    handleCurrentChange (e) {
      console.log(e)
      this.currentPage = e
      this.recruitlist()

    },
    Mouseout () {
      this.monindex = 100000
    },
    //招聘信息列表
    recruitlist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: this.currentPage,
        showCount: this.showCount,

      }
      api.recruitlist(parm).then((res) => {
        this.recruitlists = res.data.list
        this.totalResult = res.data.page.totalResult
      })
    },
  }

}
</script>

<style>
.dv-content-re {
  width: 100%;
  height: fit-content;
  display: flex;
  position: relative;
  flex-direction: column;
}
.img-re-bg {
  position: absolute;
  /* top: 40px; */
  left: 0;
  width: 100%;
}
.dv-content-s-re {
  width: calc(100% - 600px);
  height: fit-content;
  margin-left: 300px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
}
.dv-content-item-re {
  width: 100%;
  min-height: 500px;
  height: fit-content;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  margin-bottom: 200px;
  position: relative;
}
.img-re-bottom {
  width: 100%;
  position: absolute;
  bottom: 0;
}
.dv-re-white {
  width: 100%;
  height: 100px;
  background: white;
  position: absolute;
  top: 0;
}
.tv-re-title {
  font-size: 30px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  margin-top: 20px;
  margin-left: 20px;
  margin-bottom: 20px;
  text-align: left;
  color: #333333;
}
.dv-re-item {
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-top: 10px;
  background: #f7f9ff;
  border: 2px solid #f7f9ff;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
}
.tv-re-item-title {
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  margin: 20px 0 0 20px;
  text-align: left;
  color: #333333;
}
.tv-re-item-title1 {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  margin: 20px 0 0 20px;
  color: #666666;
}
.tv-re-item-title2 {
  font-size: 19px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 400;
  white-space: pre-wrap;
  text-align: left;
  width: calc(100% - 40px);
  line-height: 30px;
  margin: 10px 0 0 20px;
  color: #666666;
}
.dv-re-items {
  border: 2px solid #dfa813;
}
.tv-re-item-titles {
  color: #634d91;
  text-decoration: underline;
}
</style>